module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/personality-relax-2.c0516e61.png";